













import Vue from 'vue'
import Item2ColEl from '@/components/elements/Item2ColEl.vue'
import { Item2ColLinkElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'Item2ColLinkEl',

  components: { Item2ColEl },

  props: {
    templateItemData: {
      type: Object as () => Item2ColLinkElInterface,
      required: true
    }
  }
})
